module.exports = __webpack_public_path__ + "static/media/10_sahyadrihospitals.e57cb118.svg";